function a(o = []) {
  const t = (r) => Object.values(r).map((e) => Array.isArray(e[0]) ? t(e) : [e[1], e[0]]);
  return {
    type: "FeatureCollection",
    features: [
      {
        id: "schoolCatchment",
        type: "Feature",
        geometry: {
          type: "MultiPolygon",
          coordinates: t(o)
        }
      }
    ]
  };
}
export {
  a as formatGeometry
};
